import type { TelemetryEvent, TelemetryProvider } from "../../core/types.js";

const callbackRegistry = new Map<string, (event: TelemetryEvent) => void>();

export function registerCallbackProvider(
  id: string,
  handler: (event: TelemetryEvent) => void,
): () => void {
  callbackRegistry.set(id, handler);
  return () => callbackRegistry.delete(id);
}

export function createCallbackProvider(id: string): TelemetryProvider {
  return {
    id,
    type: "callback",
    send(event: TelemetryEvent) {
      const handler = callbackRegistry.get(id);
      if (!handler) {
        console.warn(
          `[telemetry] callback provider "${id}" has no registered handler. Use registerCallbackProvider().`,
        );
        return;
      }
      handler(event);
    },
  };
}
